<template>
  <a-modal
    title="自然计价"
    :width="780"
    :visible="visible"
    :confirmLoading="loading"
    @ok="ok"
    @cancel="() => { $emit('cancel') }"
  >
    <a-spin :spinning="loading">
      <a-form :form="form" v-bind="formLayout">
        <a-row :gutter="[16,16]">
          <a-col :span="12">
            <a-form-item label="锁价日期">
              <a-range-picker
                @change="time"
                format="YYYY-MM-DD"
                style="width: 100%"
                v-decorator="['lock_date', {rules: [{required: true, message: '必填项，请填写信息'}]}]">
                <template slot="dateRender" slot-scope="current">
                  <div class="ant-calendar-date" :style="getCurrentStyle(current)">
                    {{ current.date() }}
                  </div>
                </template>
              </a-range-picker>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="锁价数量">
              <a-input-number style="width: 100%" :precision="4" v-decorator="['lock_count', {rules: [{required: true, message: '必填项，请填写信息'}]}]" placeholder="请输入"/>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="是否转月">
              <a-switch v-decorator="['is_rollover', { initialValue: false, valuePropName: 'checked' }]" checked-children="是" un-checked-children="否" @change="rolloverChange"/>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="月差">
              <a-input-number style="width: 100%" :precision="4" v-decorator="['monthly_spread', {initialValue: 0, rules: [{required: this.rollover, message: '必填项，请填写信息'}]}]" placeholder="请输入"/>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-table
              style="width: 100%"
              v-if="turningMonthList.length > 0 "
              :data-source="turningMonthList"
              ref="turningMonthTable"
              :columns="turningMonthColumns"
              :pagination="false">
              <template
                v-for="col in ['lock_price']"
                :slot="col"
                slot-scope="text, record"
              >
                <div :key="col">
                  <a-input-number
                    v-if="record.editable"
                    style="margin: -5px 0"
                    :value="text"
                    :precision="4"
                    @change="e => handleChange(e, record.key, col)"
                  />
                  <template v-else>
                    {{ text }}
                  </template>
                </div>
              </template>
              <span slot="serial" slot-scope="text, record, index">
                {{ index + 1 }}
              </span>
              <template slot="action" slot-scope="text, record">
                <a-popconfirm
                  title="确定删除吗?"
                  @confirm="() => onDeleteItem(record.key)"
                >
                  <a href="javascript:;">删除</a>
                </a-popconfirm>
                <a-divider type="vertical" />
                <span v-if="record.editable">
                  <a @click="() => save(record.key)">保存</a>
                  <a-divider type="vertical" />
                  <a-popconfirm title="确定取消吗?" @confirm="() => cancel(record.key)">
                    <a>取消</a>
                  </a-popconfirm>
                </span>
                <span v-else>
                  <a :disabled="editingKey !== ''" @click="() => edit(record.key)">编辑</a>
                </span>
              </template>
            </a-table>
          </a-col>
        </a-row>
      </a-form>
    </a-spin>
  </a-modal>
</template>
<script>
export default {
  components: {},
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    loading: {
      type: Boolean,
      default: () => false
    },
    model: {
      type: Object,
      default: () => null
    }
  },
  data () {
    this.formLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 6 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 18 }
      }
    }

    return {
      form: this.$form.createForm(this),
      dictionaries: this.$Dictionaries,
      labelCol: {
        xs: { span: 24 },
        sm: { span: 3 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 21 }
      },
      rollover: false,
      param: {},
      editingKey: '',
      turningMonthList: [],
      cacheData: [],
      turningMonthColumns: [
        {
          title: '序号',
          width: 80,
          scopedSlots: { customRender: 'serial' }
        },
        {
          title: '计价日期',
          dataIndex: 'lock_price_date',
          width: 150,
          align: 'center',
          ellipsis: true
        },
        {
          title: '计价价格',
          dataIndex: 'lock_price',
          width: 150,
          align: 'center',
          ellipsis: true,
          scopedSlots: { customRender: 'lock_price' }
        },
        {
          width: 100,
          title: '操作',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' }
        }
      ]
    }
  },
  methods: {
    time (dates, dateStrings) {
      this.param.start_date = dateStrings[0]
      this.param.end_date = dateStrings[1]
      if (!dates) {
        this.dateList = []
        return
      }
      this.turningMonthList = []
      this.cacheData = []
      this.dateList = this.generateDateRange(dates)
      if (this.dateList) {
        for (let i = 0; i < this.dateList.length; i++) {
          this.turningMonthList.push({
            lock_price_date: this.dateList[i],
            lock_price: 0,
            key: i,
            editable: false
          })
        }
        this.cacheData = this.turningMonthList.map(item => ({ ...item }))
      }
    },
    generateDateRange (dates) {
      if (!dates || dates.length !== 2) return []

      const start = new Date(dates[0])
      const end = new Date(dates[1])

      if (start > end) return []

      const result = []
      const current = start.getTime()
      const last = end.getTime()
      const oneDay = 86400000 // 24 * 60 * 60 * 1000

      for (let time = current; time <= last; time += oneDay) {
        const date = new Date(time)
        const year = date.getFullYear()
        const month = String(date.getMonth() + 1).padStart(2, '0')
        const day = String(date.getDate()).padStart(2, '0')
        result.push(`${year}-${month}-${day}`)
      }
      return result
    },
    getCurrentStyle (current, today) {
      const style = {}
      if (current.date() === 1) {
        style.border = '1px solid #1890ff'
        style.borderRadius = '50%'
      }
      return style
    },
    onDeleteItem (key) {
      const dataSource = [...this.turningMonthList]
      this.turningMonthList = dataSource.filter(item => item.key !== key)
    },
    rolloverChange (value) {
      this.rollover = value
    },
    ok () {
      const data = {}
      const priceList = this.turningMonthList.map(item => Number(item.lock_price))
      data['lock_price'] = this.average(priceList)
      data['nature_price_list'] = this.turningMonthList
      if (this.dateList.length === this.turningMonthList.length) {
        data['lock_date'] = this.param.start_date + '~' + this.param.end_date
        data['is_consecutive_dates'] = true
      } else {
        data['is_consecutive_dates'] = false
        data['lock_date'] = this.turningMonthList.map(item => item.lock_price_date).join(',')
      }
      this.$emit('ok', data)
    },
    average (numbers) {
      if (numbers.length === 0) return '0.0000'
      const sum = numbers.reduce((a, b) => a + b, 0)
      const avg = sum / numbers.length
      // 四舍五入到 4 位小数
      return avg.toFixed(4)
    },
    handleChange (value, key, column) {
      const newData = [...this.turningMonthList]
      const target = newData.find(item => key === item.key)
      if (target) {
        target[column] = value
        this.turningMonthList = newData
      }
    },
    edit (key) {
      const newData = [...this.turningMonthList]
      const target = newData.find(item => key === item.key)
      this.editingKey = key
      if (target) {
        target.editable = true
        this.turningMonthList = newData
      }
    },
    save (key) {
      const newData = [...this.turningMonthList]
      const newCacheData = [...this.cacheData]
      const target = newData.find(item => key === item.key)
      const targetCache = newCacheData.find(item => key === item.key)
      if (target && targetCache) {
        delete target.editable
        this.turningMonthList = newData
        Object.assign(targetCache, target)
        this.cacheData = newCacheData
      }
      this.editingKey = ''
    },
    cancel (key) {
      const newData = [...this.turningMonthList]
      const target = newData.find(item => key === item.key)
      this.editingKey = ''
      if (target) {
        Object.assign(target, this.cacheData.find(item => key === item.key))
        delete target.editable
        this.turningMonthList = newData
      }
    }
  }
}
</script>
